const ThankYouSuran = () => {
  return (
    <div className="content-container">
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Thank You!</h2>
        <p>
          Your form has been successfully submitted and payment of $175
          received.
        </p>
        <p>We appreciate your time and effort in completing this form.</p>
      </div>
    </div>
  );
};

export default ThankYouSuran;
